import { Box, Paper, Typography } from '@mui/material'
import React, { useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import FormInput from '../inputs/FormInput'
import Btn from '../global/Btn'
import { useNavigate } from 'react-router-dom'
import { useAuthContext } from '../../auth/useAuthContext'
import i18next from 'i18next';

const FormLogin = () => {
    let lng = i18next.language
    const form = useRef();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const NewLoginSchema = Yup.object().shape({
        email: Yup.string(),
        password: Yup.string(),
    });
    const { handleSubmit, reset } = useForm({
        resolver: yupResolver(NewLoginSchema),
    });

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuthContext();
    const SubmitForm = async () => {
        setLoading(true);
        try {
            const result = await login(email, password);
            if (result.status === 'success') {
                enqueueSnackbar(result.message, { variant: 'success' });
                navigate('/');
            } else {
                enqueueSnackbar(result.message, { variant: 'error' });
            }
            reset();
        } catch (err) {
            console.error("SubmitForm Error:", err);
            enqueueSnackbar(err?.response?.data?.message || 'حدث خطأ في الشبكة', { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Paper
                elevation={4}
                sx={{
                    px: { md: 4, xs: 2 },
                    py: { md: 4, xs: 2 },
                    borderRadius: 3,
                    maxWidth: 420,
                    mx: 'auto',
                    bgcolor: 'background.paper',
                }}
            >
                <Typography variant="h5" textAlign="center" sx={{ mb: { md: 3, xs: 1 } }}>
                    Log In
                </Typography>

                <Box component={'form'} ref={form} onSubmit={handleSubmit(SubmitForm)}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: { md: 2, xs: 1 } }}>
                        <FormInput
                            label={lng === 'ar' ? 'ادخل اسم المستخدم او البريد الإلكتروني' : 'Enter Username or Email'}
                            type="email"
                            value={email}
                            placeholder="example@example.com"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <FormInput
                            label={lng === 'ar' ? 'ادخل كلمة المرور' : 'Enter Password'}
                            type="password"
                            placeholder="*********"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Box>

                    <Box mt={3} textAlign="center" sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Btn type="submit" width="100%" widthMob="100%" disabled={loading} sx={{ mx: '0' }}>
                            {loading ? 'Loading...' : 'Log In'}
                        </Btn>
                    </Box>
                </Box>
            </Paper>
        </>
    )
}

export default FormLogin
